<template>
  <CalculationElementLayout
    :child-elements="['setupStep']"
    :node-id="nodeId"
    :level="2">
    <MachineTabs
      v-if="level < 2"
      :node-id="nodeId" />
    <MachineTabsLevel2
      v-if="level === 2"
      :node-id="nodeId" />
  </CalculationElementLayout>
</template>

<script setup>
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import ElementButtons from "@/components/Elements/ElementButtons.vue";
import MachineTabs from "./MachineTabs.vue";
import MachineTabsLevel2 from "./MachineTabsLevel2.vue";
import CalcLevel from "@/components/Elements/CalcLevel.vue";
import { ref } from "vue";
import { useSpaceStore } from "../../../stores/spaceStore";
import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";

const { t } = useTranslation();
const route = useRoute();
const { required } = useCommonRules(t);

const spaceStore = useSpaceStore();

const level = computed(() => {
  return spaceStore.calculationElements[nodeId.value].level;
});

const nodeId = computed(() => route.params.nodeId);
</script>
